import { Component, OnDestroy, OnInit } from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { Router } from "@angular/router";
import { PromotionsService } from "src/app/features/promotions/promotions.service";

@Component({
  selector: "app-manage-consumer-banner",
  templateUrl: "./manage-consumer-banner.component.html",
  styleUrls: ["./manage-consumer-banner.component.scss"],
})
export class ManageConsumerBannerComponent
  extends FeaturesBaseComponent
  implements OnInit, OnDestroy
{
  searchValue: string;
  rowSelection;
  rowData;
  columnDefs;
  private gridApi;
  private gridColumnApi;
  selectedRows: any;
  showUpdateRetailer: boolean;
  bannerId: any;
  constructor(
    private promotionService: PromotionsService,
    private router: Router
  ) {
    super();
    this.getAllBannersData();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  getAllBannersData() {
    this.promotionService.getConsumerPromotions().subscribe({
      next: (res: any) => {
        if (res["httpcode"] == 200) {
          console.log(res);
          this.setGrid(res.data);
        }
      },
    });
  }

  setGrid(data: any) {
    this.rowData = data;
    this.rowSelection = "single";

    this.columnDefs = [
      {
        field: "consumerCarrierPromotionId",
        headerName: "consumerCarrierPromotionId",
        width: 0,
        hide: true,
        sort: "desc",
      },
      { field: "", headerName: "Action", width: 160, checkboxSelection: true },
      {
        field: "editedPromotionName",
        headerName: "Promotion Name",
        width: 240,
      },
      {
        field: "editedPromotionDescription",
        headerName: "Promotion Description",
        width: 300,
      },
      {
        field: "applicableMaxAmount",
        headerName: "Max Amount",
        width: 240,
      },
      {
        field: "applicableMinAmount",
        headerName: "Min Amount",
        width: 240,
      },
      {
        field: "promotionStartdttm",
        headerName: "Start Date",
        width: 240,
      },
      {
        field: "promotionEnddttm",
        headerName: "End Date",
        width: 240,
      },
      {
        field: "tilaCountry",
        headerName: "Tila Country",
        width: 240,
      },
      {
        field: "tilaCarrier",
        headerName: "Tila Carrier",
        width: 240,
      },
      { field: "isCertified", headerName: "Display Promotion", width: 240 },
    ];
  }

  // On grid ready
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  managePromotion() {
    this.router.navigate([
      `features/consumers/consumer-banner/edit-banner/${this.bannerId}`,
    ]);
  }
  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();

    if (this.selectedRows && this.selectedRows.length > 0) {
      this.showUpdateRetailer = true;
      this.bannerId = this.selectedRows[0].consumerCarrierPromotionId;

      return;
    }
    this.showUpdateRetailer = false;
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  addPromotionConfig() {
    this.router.navigate([`features/consumers/consumer-banner/add-banner`]);
  }
}
